<template>
  <div class="row destination-carousel mt-4">
    <div class="d-none d-md-block col-md-2"></div>
    <div class="col-12 col-md-8">
      <div id="cenas" class="carousel slide carousel-fade" data-ride="carousel">
        <div class="carousel-inner">
          <div v-for="(asset, index) in assets" class="carousel-item" :class="{'active': index === 0}">
            <img :src="getImgUrl(asset)" class="d-block h-400px" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="d-none d-md-block col-md-2"></div>
  </div>
</template>

<script>
  export default {
    name: 'DestinationPageCarousel',
    props: [
      'carouselId',
      'assets',
    ],
    data: function () {
      return {
      }
    },
    methods: {
      getImgUrl: function (image) {
        return `/static-assets/destinations/${image}.jpg`;
      }
    }
  }
</script>

<style scoped lang="scss">

</style>